import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailAddonLogo = styled.img<React.CSSProperties>`
  position: absolute;
  height: ${Screen.widthRatio * 150}px;
  left: ${Screen.widthRatio * 90}px;
  top: ${Screen.widthRatio * 90}px;
`;

export default DetailAddonLogo;
